<template>
    <div>
        <div class="content">
            <p class="allrecord">全部消费</p>
            <el-divider></el-divider>
            <el-table :data="recordlist">
                <el-table-column prop="created" label="时间"></el-table-column>
                <el-table-column prop="typename" label="类别"></el-table-column>
                <el-table-column prop="remark" label="详情"></el-table-column>
                <el-table-column prop="amount" label="金额"></el-table-column>
                <el-table-column prop="statusname" label="状态"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                recordlist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getrecordlist();
        },
        methods: {
            getrecordlist() {
                this.httpGet(this.$root.getExpenses, {
                    page: this.page
                })
                    .then(result => {
                        if (result.count) {
                            this.recordlist.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.recordlist = [];
                            this.total = 0;
                        }
                        console.log(result.list, 222);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.recordlist = [];
                this.getrecordlist();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.recordlist = [];
                this.getrecordlist();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.recordlist = [];
                this.getrecordlist();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .content {
        background-color: white;
        border-radius: 8px;
        width: 832px;
        padding: 24px;

        .allrecord {
            font-size: 16px;
        }
    }

    >>>.el-pagination {
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
